import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-videos',
  templateUrl: './tutorial-videos.component.html',
  styleUrls: ['./tutorial-videos.component.scss']
})
export class TutorialVideosComponent implements OnInit {

	bgTextColor = "#000000";

  constructor() { }

  ngOnInit(): void {
    this.onInit();
  }

  onInit(): void {
    if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
  }

}
